import React, { useState } from 'react';

const clientSteps = [
  {
    icon: '🔍',
    title: 'Discover',
    desc: 'Browse verified Ghanaian tailors by style, location and rating. See real portfolios before you commit.',
  },
  {
    icon: '📐',
    title: 'Order',
    desc: 'Submit your measurements and style inspiration securely. No awkward DMs or lost voice notes.',
  },
  {
    icon: '🛡️',
    title: 'Trust',
    desc: 'Pay safely with escrow. Your money is protected until you receive your outfit and love it.',
  },
];

const tailorSteps = [
  {
    icon: '🏪',
    title: 'Get Found',
    desc: 'A professional profile that showcases your best work to thousands of potential clients — not just your area.',
  },
  {
    icon: '💼',
    title: 'Manage Orders',
    desc: 'Track every order, measurement and deadline in one place. No more notebooks, no more missed deadlines.',
  },
  {
    icon: '📈',
    title: 'Grow',
    desc: 'Verified reviews, pricing confidence and real business data. Build a reputation that travels with you.',
  },
];

function StepCard({ icon, title, desc, index }) {
  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: '16px',
      padding: '32px 28px',
      position: 'relative',
      transition: 'border-color 0.3s, transform 0.3s',
      animation: `reveal 0.6s ease ${index * 0.12}s both`,
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(240,165,0,0.4)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      <div style={{
        position: 'absolute', top: '-14px', left: '28px',
        background: 'var(--gold)', color: '#000',
        width: '28px', height: '28px', borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '0.75rem', fontWeight: '700',
      }}>{index + 1}</div>
      <div style={{ fontSize: '2.2rem', marginBottom: '16px' }}>{icon}</div>
      <h3 style={{
        fontFamily: 'var(--font-display)',
        fontSize: '1.5rem', fontWeight: '600',
        color: '#fff', marginBottom: '10px',
      }}>{title}</h3>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.925rem', lineHeight: '1.65' }}>{desc}</p>
    </div>
  );
}

export default function HowItWorks() {
  const [tab, setTab] = useState('client');
  const steps = tab === 'client' ? clientSteps : tailorSteps;

  return (
    <section id="how-it-works" style={{
      padding: '100px 24px',
      background: 'var(--bg)',
      position: 'relative',
    }}>
      {/* Section label */}
      <div style={{ maxWidth: '960px', margin: '0 auto' }}>
        <div style={{
          textAlign: 'center', marginBottom: '56px',
        }}>
          <p style={{
            fontSize: '0.75rem', letterSpacing: '0.18em', textTransform: 'uppercase',
            color: 'var(--gold)', fontWeight: '500', marginBottom: '14px',
          }}>How It Works</p>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(2rem, 4.5vw, 3.2rem)',
            fontWeight: '600', color: '#fff',
            marginBottom: '16px',
          }}>
            Built for <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>everyone</span> in the ecosystem
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1rem', maxWidth: '480px', margin: '0 auto' }}>
            Whether you wear it or make it, Kaftora gives you superpowers.
          </p>
        </div>

        {/* Tab Toggle */}
        <div style={{
          display: 'flex', justifyContent: 'center', marginBottom: '48px',
        }}>
          <div style={{
            background: 'var(--surface)', borderRadius: '10px', padding: '4px',
            display: 'flex', border: '1px solid var(--border)',
          }}>
            {['client', 'tailor'].map(t => (
              <button key={t} onClick={() => setTab(t)} style={{
                background: tab === t ? 'var(--gold)' : 'transparent',
                color: tab === t ? '#000' : 'var(--text-muted)',
                border: 'none', borderRadius: '7px',
                padding: '10px 32px',
                fontSize: '0.9rem', fontWeight: tab === t ? '600' : '400',
                fontFamily: 'var(--font-sans)', cursor: 'pointer',
                transition: 'all 0.25s ease',
                textTransform: 'capitalize',
              }}>
                {t === 'client' ? '👗 For Clients' : '✂️ For Tailors'}
              </button>
            ))}
          </div>
        </div>

        {/* Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '24px',
        }}>
          {steps.map((s, i) => <StepCard key={`${tab}-${i}`} {...s} index={i} />)}
        </div>
      </div>
    </section>
  );
}
